import { createContext } from 'react';

const noop = () => {
  // No-op default; provider injects the real close handler.
};

export const CloseHeaderDropdownContext = createContext<() => void>(noop);
